<template>
<div>
  <el-form style="margin-right: 30px" :model="editForm" :rules="editRules" ref="editForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="退宿原因" prop="">
      <el-select v-fixZoom v-model="editForm.val" filterable placeholder="请选择" style="width: 100%">
        <el-option v-for="item in reasonArr" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="退宿时间" prop="">
      <el-date-picker v-fixZoom style="width: 100%" v-model="editForm.time" :clearable="false"
                      type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="备注" prop="">
      <el-input type="textarea" :rows="2" v-model="editForm.name" placeholder="请输入备注"></el-input>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditUnit('editForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
export default {
  name: 'editLeave',
  model: {
    prop: 'openShow',
    event: 'change'
  },
  props: {
    editObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      reasonArr: [
        {id: 0, name: '去世'},
        {id: 1, name: '离院'},
        {id: 2, name: '劝退'}
      ],
      editForm: {
        val: '',
        time: '',
        name: ''
      },
      editRules: {}
    }
  },
  created () {
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEditUnit (formName) {
      this.$refs[formName].validate((valid) => {
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/editLeave.vue